export default __webpack_public_path__ + "static/media/EAST1030.34I-34161_-18407_0.54464ac0.jpg";